"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSubjectEnum = void 0;
var NotificationSubjectEnum;
(function (NotificationSubjectEnum) {
    NotificationSubjectEnum["NewAssignment"] = "A";
    NotificationSubjectEnum["NewInternal"] = "-";
    NotificationSubjectEnum["NewResponseOnMyConversation"] = "B";
    NotificationSubjectEnum["ConversationMessagesImTaggedIn"] = "C";
    NotificationSubjectEnum["StatusUpdateOnMyConversation"] = "D";
    NotificationSubjectEnum["ConversationAssignedToMe"] = "E";
    NotificationSubjectEnum["ConversationAssignedToMyQueues"] = "F";
    NotificationSubjectEnum["ReminderOnFirstResponse"] = "G";
    NotificationSubjectEnum["ReminderOnResolutionTime"] = "H";
    NotificationSubjectEnum["ReminderOnNextResponse"] = "I";
    NotificationSubjectEnum["SysInfo"] = "J";
    NotificationSubjectEnum["SysError"] = "K";
    NotificationSubjectEnum["PasswordLifetimeExpiryClose"] = "L";
    NotificationSubjectEnum["StatsAlarm"] = "M";
})(NotificationSubjectEnum = exports.NotificationSubjectEnum || (exports.NotificationSubjectEnum = {}));
